import { useMemo } from 'react';

import { SelectedReceiver, toSelectedReceiver } from '../components/transaction/SelectedReceiver';
import useOcr from '../fetchHooks/useOcr';
import { useSingleReceiver } from '../fetchHooks/useReceivers';
import type { AccountNumber } from '../generated-types';
import useQueryParam from './queryparams/useQueryParam';

const asAccountNumber = (value: undefined | string): AccountNumber | undefined => (value ? { value } : undefined);

const useReceiverAccount = (): SelectedReceiver | undefined => {
    const receiverAccountNumber = useQueryParam('receiverAccountNumber');
    const { data: existingReceiver } = useSingleReceiver(asAccountNumber(receiverAccountNumber));
    const { data: ocrInfo } = useOcr(asAccountNumber(receiverAccountNumber));

    return useMemo(() => {
        if (receiverAccountNumber && ocrInfo) {
            const accountNumber = { value: receiverAccountNumber };
            const receiver = existingReceiver ?? { accountNumber };
            return toSelectedReceiver(receiver, ocrInfo);
        }
        return undefined;
    }, [existingReceiver, ocrInfo, receiverAccountNumber]);
};
export default useReceiverAccount;
